module.exports = __webpack_public_path__ + "img/part_c.576c14f0.png";